(function ($, root, undefined) {

    $(function () {

        var $body = $('body');

		/* ========================================================
				Top Navigation
		======================================================== */

		/*
		 *  cache these jquery objects
		 */
        var $siteheader = $('.siteheader');
        var $topNavToggles = $('.js-top-nav-toggle');
        var $superfly = $('.superfly');
        var $superflyHeader = $('.superfly-header');

		/*
		 *  bind the events and trigger the fucntions
		 */
        $topNavToggles.on('click', function () {
            navToggle($(this));
        });

        $(document).on('click', function () {
            menuStates.close();
        });

        $('.js-superfly').on('click', function (e) {
            e.stopPropagation();
            menuStates.open($(this));
        });

        //make it tab & return friendly
        $('.js-superfly ').on('keypress', function (event) {
            if (event.keyCode == 13) {
                $(this).click();
            }
        });

        //clos menu on esc
        $('body').on('keypress', function (event) {
            if (event.keyCode == 27) {
                menuStates.close();
            }
        });

        $('.megamenu, .siteheader').click(function (e) {
            e.stopPropagation();
        });

        //simple one for mobile menu sub sections
        $superflyHeader.on('click', function (e) {
            if ($superfly.css('position') == 'fixed') {
                e.preventDefault();
                $(this).parent('.superfly').removeClass('superfly-open');
            }
        });

		/*
		 *  the functions
		 */

        //control zee menus!
        var menuStates = (function () {

            var menuStates = function () { };

            menuStates.close = function () {
                $('.js-superfly').removeClass('is-active');
                $('.megamenu').removeClass('is-open');
            };

            menuStates.open = function (el) {
                $('.js-superfly').not(el).removeClass('is-active');
                $('.megamenu').removeClass('is-open');

                if ($superfly.css('position') == 'fixed') {
                    rel = el.attr('data-rel');
                    selector = '.superfly[data-rel="' + rel + '"]';
                    $(selector).addClass('superfly-open');
                }

                else {
                    if (el.is('.is-active')) {
                        menuStates.close();
                    }
                    else {
                        rel = el.attr('data-rel');
                        selector = '.megamenu[data-rel="mega-' + rel + '"]';
                        el.addClass('is-active');
                        $(selector).addClass('is-open');
                    }
                }
            };

            return menuStates;

        })();

        //Control states through class activation, then override styles on desktop - no need to listen to window resize and deal with differening breakpoints in cross browser
        function navToggle($element) {
            //don't execute if the element is-disabled. removed with setTimeout and set by the corresponding animation value of the animating element.
            if (!$element.hasClass('is-disabled')) {

                //add the disabled class to prevent further clicks while menu animation completes
                $element.addClass('is-disabled');
                //use top--nav main to grab the transition duration for.
                varTimeout = transitionTimeout($('.topnav--main'));

                if ($element.attr('data-nav-toggle') === 'search') {
                    if ($siteheader.hasClass('has-open-nav')) {
                        $siteheader.removeClass('has-open-nav').addClass('has-open-search');
                    }
                    else {
                        $body.toggleClass('has-open-nav-element');
                        $siteheader.toggleClass('has-open-search');
                    }
                }

                if ($element.attr('data-nav-toggle') === 'nav') {
                    if ($siteheader.hasClass('has-open-search')) {
                        $siteheader.removeClass('has-open-search').addClass('has-open-nav');
                    }
                    else {
                        $body.toggleClass('has-open-nav-element');
                        $siteheader.toggleClass('has-open-nav');
                    }
                }
                //remove the disabled class
                setTimeout(function () {
                    $('.superfly').removeClass('superfly-open');
                    $element.removeClass('is-disabled');
                }, varTimeout);
            }
        }

        //Add timeout for toggle element to disable firing while animating.
        function transitionTimeout(el) {
            //Grab transitoin duration of global-navs, convert to MS, use for disable funciton at end
            var varTimeout = el.css('transition-duration');
            varTimeout = css_time_to_milliseconds(varTimeout);
            varTimeout = varTimeout + 10; //Add 10ms for good measure :(

            return varTimeout;
        }

        
    });

})(jQuery, this);

//Convert CSS transition time into milliseconds, e.g. transition: 0.2s == 200
function css_time_to_milliseconds(time_string) {
    var num = parseFloat(time_string, 10),
        unit = time_string.match(/m?s/),
        milliseconds;

    if (unit) {
        unit = unit[0];
    }

    switch (unit) {
        case "s": // seconds
            milliseconds = num * 1000;
            break;
        case "ms": // milliseconds
            milliseconds = num;
            break;
        default:
            milliseconds = 0;
            break;
    }

    return milliseconds;
}


function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function handleApiResponse(data) {
    if (data && data.UserName) {
        $('.if-logged-in').css('display', 'inline-block');
        $('.if-logged-out').css('display', 'none');
        $('.logged-in-user-name').text(data.FirstName);
        $('.cart-item-count').text(data.CartCount);
        if (data.IsClubCameronUser) {
            $('.if-club-member').css('display', 'inline-block');
        } else {
            $('.if-club-member').css('display', 'none');
        }
    } else {
        $('.if-logged-in').css('display', 'none');
        $('.if-logged-out').css('display', 'inline-block');
        $('.logged-in-user-name').text('');
        if (data && data.CartCount && !data.UserName) {
            $('.cart-item-count').text(data.CartCount);
        }
        else {
            console.log('Did not get a valid response from the store API');
        }
    }
}

function UpdateHeader(){
    var config = window.storeApiConfig || {};
    if (config.url) {
            if (config.testResponse) {
                handleApiResponse(config.testResponse);
            } else {
                $.ajax({
                    dataType: 'json',
                    method: 'GET',
                    url: config.url,
                    success: handleApiResponse,
                    error: function () {
                        console.log('Could not retrieve user information from store API');
                    }
                });
            }
    }
}

UpdateHeader();
